/**
 *
 * ModalContent
 *
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideAuthCTAModal, signUp } from 'containers/Auth/actions';
import { makeSelectAuthCTAModalProvider } from 'containers/Auth/selectors';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import FacebookButton from 'components/SocialButtons/FacebookButton';
import GoogleButton from 'components/SocialButtons/GoogleButton';
import MicrosoftButton from 'components/SocialButtons/MicrosoftButton';

const useStyles = makeStyles(theme => ({
  container: {
    zIndex: 9998,
    boxShadow:
      '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    backgroundColor: 'white',
    position: 'fixed',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      bottom: 0,
      left: 0,
      right: 0,
      height: 'min-content',
    },
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
      top: 16,
      right: 16,
    },
  },
  header: {
    width: 'min-content',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '12px 16px',
  },
  buttonContainer: {
    padding: '12px 16px',
    marginBottom: -10,
  },
  headerText: {
    fontSize: 16,
  },
  closeIcon: {
    padding: 0,
  },
  closeImage: {
    width: 24,
    height: 24,
  },
}));

const ModalContent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const provider = useSelector(makeSelectAuthCTAModalProvider());

  const handleClose = () => {
    dispatch(hideAuthCTAModal());
  };
  const handleClick = () => {
    let providerName;
    if (provider.method === 'google.com') providerName = 'google';
    else if (provider.method === 'facebook.com') providerName = 'facebook';
    else providerName = provider.method;
    dispatch(
      signUp({
        provider: { provider: providerName, type: 'popup' },
        dispatch,
      }),
    );
  };

  return (
    <Grid container justify="center" className={classes.container}>
      <Grid item xs={12} className={classes.header}>
        {provider.type === 'welcome-back' && (
          <Typography className={classes.headerText}>Welcome back!</Typography>
        )}
        {provider.type === 'previous-provider' && (
          <Typography className={classes.headerText}>
            Oops! Seems like you signed up using another account before.
          </Typography>
        )}
        <IconButton
          className={classes.closeIcon}
          onClick={handleClose}
          aria-label="Close"
          disableRipple
          disableFocusRipple
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} className={classes.buttonContainer}>
        {(provider.method === 'google' || provider.method === 'google.com') && (
          <GoogleButton
            text="Sign in again with Google"
            fullWidth
            onClick={handleClick}
          />
        )}
        {(provider.method === 'facebook' ||
          provider.method === 'facebook.com') && (
          <FacebookButton
            text="Sign in again with Facebook"
            fullWidth
            onClick={handleClick}
          />
        )}
        {provider.method === 'microsoft.com' && (
          <MicrosoftButton
            text="Sign in again with Microsoft"
            fullWidth
            onClick={handleClick}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default ModalContent;
